import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDotGrid1x3Horizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"dot-grid-1x3-horizontal, menu, drag, grab"} maskId="square-filled-radius-0-stroke-1-IconDotGrid1x3Horizontal"><path d="M5 10.5H2V13.5H5V10.5Z" fill="currentColor"/><path d="M13.5 10.5H10.5V13.5H13.5V10.5Z" fill="currentColor"/><path d="M22 10.5H19V13.5H22V10.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDotGrid1x3Horizontal;
